import React from 'react'
import { IconCheckDefault, IconCloseDefault } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import {
  TableFeature,
  useBenefitTranslation,
  useTiersInfo,
  type PlansTier,
} from '@mc/plans-ui'
import { CHECKOUT_I18N_NAMESPACE } from '../../../../i18n'

export const OfflineDownloadFeature = () => {
  const { t } = useTranslation(CHECKOUT_I18N_NAMESPACE)
  const { duo, family, individual } = useTiersInfo()

  return (
    <TableFeature.Feature>
      <TableFeature.Label title={t('plans.features.offlineDownload.title')} />
      <TableFeature.Individual>
        <BenefitIcon tier={individual} />
      </TableFeature.Individual>
      <TableFeature.Duo>
        <BenefitIcon tier={duo} />
      </TableFeature.Duo>
      <TableFeature.Family>
        <BenefitIcon tier={family} />
      </TableFeature.Family>
    </TableFeature.Feature>
  )
}

const BenefitIcon = ({ tier }: { tier: PlansTier }) => {
  const { t: tb } = useBenefitTranslation({
    name: 'offline_download',
    ns: CHECKOUT_I18N_NAMESPACE,
  })

  const { value: isIncluded } =
    tier.entitlement?.benefits?.find(
      (benefit) => benefit.name === 'offline_download',
    ) || {}

  const Icon = isIncluded ? IconCheckDefault : IconCloseDefault

  return (
    <Icon
      size={2}
      srText={tb('plans.features.offlineDownload.included', {
        tier,
        defaultValue: false,
      })}
    />
  )
}
